var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.737.002a.999.999 0 01.691.343l4.334 5c.265.305.32.74.14 1.102L8.223 9.803l5.98 5.98 3.356-1.678a.998.998 0 011.1.138l5 4.31a.999.999 0 01.098 1.418l-2.899 3.297c-.368.372-.925.733-1.856.733-2.579 0-7.284-2.974-11.708-7.401-2.557-2.557-4.676-5.253-5.966-7.592C-.19 6.253-.408 4.304.681 3.215L4.008.252c.2-.177.464-.267.73-.25zM4.58 2.42L2.124 4.601c-.165.235-.284 1.191.957 3.441 1.201 2.179 3.2 4.716 5.628 7.143 4.424 4.428 8.606 6.816 10.294 6.816.22 0 .342-.043.38-.08l2.206-2.512-3.73-3.217-3.405 1.702a.999.999 0 01-1.154-.187l-7-7a1 1 0 01-.188-1.154L7.813 6.15 4.58 2.42z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconPhone;